let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5xERA")).then(() => parcelRequire('1J3S4'));